import { gql } from "@apollo/client";

export const USER_LOGIN = gql`
  mutation LoginUser($where: LoginUserInput!) {
    loginUser(where: $where) {
        accessToken
        refreshToken
        data {
            id
            nickname
            phone
            role
            platform
            gender
            shop {
                id
            }
            permission {
                id
                name
                permissions
                platform
            }
            maritualStatus
            userSub
            email
            isConfirmed
            username
            createdAt
            updatedAt
        }
    }
}
`;